import { render, staticRenderFns } from "./stockOrderTable.vue?vue&type=template&id=c17d2b7a"
import script from "./stockOrderTable.vue?vue&type=script&lang=js"
export * from "./stockOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports